import { tv } from '~/utils/tv'

export const selectHelperTextVariants = tv({
  base: 'justify-star flex w-[100%] flex-wrap items-center gap-onepulse px-twopulse text-left font-rdmodern font-semibold text-text-neutral-alternative text-threepulse tracking-inline-onepulse',
  variants: {
    hasError: {
      true: 'text-text-danger-alternative',
      false: '',
    },
    readOnly: {
      true: 'cursor-not-allowed',
    },
    disabled: {
      true: 'cursor-not-allowed text-text-neutral-disabled',
      false: '',
    },
  },
  compoundVariants: [
    {
      readOnly: true,
      disabled: false,
      class: 'text-text-neutral-readonly',
    },
  ],
  defaultVariants: {
    error: false,
    disabled: false,
    readOnly: false,
  },
})
